var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgList(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 11,
    viewBox: "0 0 14 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.66667 6.16732C2.03486 6.16732 2.33333 5.86884 2.33333 5.50065C2.33333 5.13246 2.03486 4.83398 1.66667 4.83398C1.29848 4.83398 1 5.13246 1 5.50065C1 5.86884 1.29848 6.16732 1.66667 6.16732Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.66667 2.16732C2.03486 2.16732 2.33333 1.86884 2.33333 1.50065C2.33333 1.13246 2.03486 0.833984 1.66667 0.833984C1.29848 0.833984 1 1.13246 1 1.50065C1 1.86884 1.29848 2.16732 1.66667 2.16732Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1.66667 10.1673C2.03486 10.1673 2.33333 9.86884 2.33333 9.50065C2.33333 9.13246 2.03486 8.83398 1.66667 8.83398C1.29848 8.83398 1 9.13246 1 9.50065C1 9.86884 1.29848 10.1673 1.66667 10.1673Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13 5.50065L5 5.50065M13 1.50065L5 1.50065M13 9.50065L5 9.50065M2.33333 5.50065C2.33333 5.86884 2.03486 6.16732 1.66667 6.16732C1.29848 6.16732 1 5.86884 1 5.50065C1 5.13246 1.29848 4.83398 1.66667 4.83398C2.03486 4.83398 2.33333 5.13246 2.33333 5.50065ZM2.33333 1.50065C2.33333 1.86884 2.03486 2.16732 1.66667 2.16732C1.29848 2.16732 1 1.86884 1 1.50065C1 1.13246 1.29848 0.833984 1.66667 0.833984C2.03486 0.833984 2.33333 1.13246 2.33333 1.50065ZM2.33333 9.50065C2.33333 9.86884 2.03486 10.1673 1.66667 10.1673C1.29848 10.1673 1 9.86884 1 9.50065C1 9.13246 1.29848 8.83398 1.66667 8.83398C2.03486 8.83398 2.33333 9.13246 2.33333 9.50065Z",
    stroke: "white",
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgList);
export default __webpack_public_path__ + "static/media/list.aee935cedb11316b37195383e56cf423.svg";
export { ForwardRef as ReactComponent };